{
  "close": "Закрити"
}
